'use client'
import { FC, ReactNode, useEffect } from 'react'
type B2BLayoutProps = {
  children: ReactNode
}
const B2BLayout: FC<B2BLayoutProps> = ({ children }) => {
  useEffect(() => {
    document.body.setAttribute('data-theme', 'KMRS-Purple')

    return () => {
      document.body.removeAttribute('data-theme')
    }
  }, [])
  return children
}

export default B2BLayout
